import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from '../hooks/use-i18n'
import type { Locale } from '../hooks/use-i18n'

const LOCALES: Locale[] = ['en', 'fr', 'es', 'ru', 'it', 'de', 'pt', 'hy']

const LanguageSelector: React.FC = () => {
  const { locale, setLocale, flags, localeNames } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    if (open) document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="p-2.5 md:p-2 rounded-xl hover:bg-[#E6F4EC] text-[#00413E] hover:text-[#0B3333] transition-colors"
        aria-label={localeNames[locale]}
        title={localeNames[locale]}
      >
        <span className="text-xl md:text-lg leading-none">{flags[locale]}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 py-1 min-w-[160px] rounded-lg bg-popover text-popover-foreground border border-border shadow-lg z-50 animate-in fade-in-0 zoom-in-95">
          {LOCALES.map((loc) => (
            <button
              key={loc}
              type="button"
              onClick={() => {
                setLocale(loc)
                setOpen(false)
              }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-left text-small hover:bg-muted/50 ${locale === loc ? 'bg-muted/30 font-medium' : ''}`}
            >
              <span>{flags[loc]}</span>
              <span>{localeNames[loc]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default LanguageSelector
